import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/categories").then((r) => setCats(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const body = { name: edit.name, description: edit.description };
      if (edit.id) await api.put(`/categories/${edit.id}`, body); else await api.post("/categories", body);
      toast.success("Kategori disimpan"); setEdit(null); load();
    } catch (err) { toast.error(errMsg(err)); }
  };

  const remove = async (c) => {
    if (!window.confirm(`Hapus kategori "${c.name}"?`)) return;
    try { await api.delete(`/categories/${c.id}`); toast.success("Kategori dihapus"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="max-w-3xl fade-up">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-serif text-3xl font-extrabold">Kategori</h1>
        <Button onClick={() => setEdit({ name: "", description: "" })} data-testid="new-category-button"><Plus size={16} /> Tambah</Button>
      </div>
      <div className="bg-white border border-slate-200 divide-y divide-slate-100">
        {cats.map((c) => (
          <div key={c.id} className="flex items-center gap-4 p-4" data-testid={`category-row-${c.slug}`}>
            <div className="flex-1">
              <p className="font-semibold">{c.name}</p>
              <p className="text-xs text-slate-500">{c.description || "-"} · {c.article_count} berita</p>
            </div>
            <Button variant="outline" size="icon" onClick={() => setEdit(c)} data-testid={`edit-category-${c.slug}`}><Pencil size={15} /></Button>
            <Button variant="outline" size="icon" onClick={() => remove(c)} data-testid={`delete-category-${c.slug}`}><Trash2 size={15} className="text-red-600" /></Button>
          </div>
        ))}
      </div>
      <Dialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)}>
        <DialogContent>
          <form onSubmit={save} className="space-y-4" data-testid="category-form">
            <DialogHeader><DialogTitle>{edit?.id ? "Edit Kategori" : "Kategori Baru"}</DialogTitle></DialogHeader>
            <div className="space-y-2"><Label>Nama</Label>
              <Input required value={edit?.name || ""} onChange={(e) => setEdit({ ...edit, name: e.target.value })} data-testid="category-name-input" /></div>
            <div className="space-y-2"><Label>Deskripsi</Label>
              <Input value={edit?.description || ""} onChange={(e) => setEdit({ ...edit, description: e.target.value })} data-testid="category-desc-input" /></div>
            <DialogFooter><Button type="submit" data-testid="category-save-button">Simpan</Button></DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
